// packages/ds/src/Dropdown/Root.tsx
import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { DropdownRootProps } from "./Dropdown.types";

/**
 * Root component for the Dropdown menu system
 *
 * @param props - The component props
 * @returns A Dropdown Root component
 */
export const Root = ({
  modal = false,
  children,
  onOpenChange,
  ...props
}: DropdownRootProps) => {
  return (
    <DropdownMenu.Root
      modal={modal}
      {...props}
      onOpenChange={open => {
        onOpenChange?.(open);
      }}
    >
      {children}
    </DropdownMenu.Root>
  );
};
